import { Layers, MapPin, Terminal, Globe } from 'lucide-react';

export const projects = [
  {
    title: "Qahwa - Social Media Platform",
    period: "Apr 2025 – Jul 2025",
    description: "A large-scale social media and content-sharing platform with real-time features",
    highlights: [
      "Secure Laravel backend with OTP & Google Auth authentication",
      "RESTful APIs with Sanctum-based token protection",
      "CMS for video, podcast, and interactive posts with comments, likes, and follows",
      "Real-time chat with group management via Pusher",
      "Admin Dashboard for moderation and analytics",
      "Containerized deployment with Docker, Render, and AWS S3"
    ],
    tech: ["Laravel", "MySQL", "RESTful APIs", "Sanctum", "Google Auth", "Pusher", "Docker", "AWS S3"],
    github: "https://github.com/ebraheem54/QAHWA",
    featured: true,
    icon: Layers
  },
  {
    title: "Speedo - Delivery Management System",
    period: "Feb 2024 – Apr 2024",
    description: "Backend system for a multi-role delivery platform focused on real-time logistics and tracking",
    highlights: [
      "Secure OTP SMS verification authentication backend",
      "RESTful APIs for Driver, Customer, Vendor, and Admin roles",
      "Geolocation services integration for real-time driver tracking",
      "Reduced manual tracking overhead by 30% through backend automation",
      "Real-time status control and logistics optimization"
    ],
    tech: ["Laravel", "MySQL", "RESTful APIs", "OTP SMS", "Geolocation"],
    github: "https://github.com/ebraheem54/Speedo",
    featured: true,
    icon: MapPin
  },
  {
    title: "Django Social Network",
    period: "Feb 2024 – Apr 2024",
    description: "A complete social networking platform built with Django, featuring modern UI/UX, user authentication, and comprehensive profile management",
    images: [
      '/social-1.png',
      '/social-2.png',
      '/social-3.png',
      '/social-4.png',
      '/social-5.png',
      '/social-6.png',
      '/social-7.png',
      '/social-8.png',
      '/social-9.png',
      '/social-10.png',
      '/social-11.png',
      '/social-12.png',
      '/social-13.png',
    ],
    highlights: [
      "User registration and authentication system",
      "User profiles with bio and profile pictures",
      "Post creation with captions and media upload",
      "Search functionality to find and discover friends",
      "Follow/unfollow system for user connections",
      "Account settings to update profile information",
      "Pagination on profile pages (2 posts per page)",
      "Modern gradient-based design system",
      "Fully responsive mobile-friendly layouts"
    ],
    tech: ["Django", "Python", "SQLite", "Bootstrap", "HTML/CSS", "JavaScript", "Crispy Forms"],
    github: "https://github.com/ebraheem54/social_Network",
    featured: false,
    icon: Globe
  },
  {
    title: "Task Management REST API",
    period: "Personal Project",
    description: "Robust RESTful API with full CRUD functionality for task management",
    highlights: [
      "Full CRUD for tasks with file attachments (multi-type media)",
      "Comments and custom categorization system",
      "Token-based authentication with Sanctum",
      "Advanced Laravel architecture patterns"
    ],
    tech: ["Laravel", "RESTful APIs", "Sanctum", "MySQL", "File Storage"],
    github: "https://github.com/ebraheem54",
    featured: false,
    icon: Terminal
  }
];
